import React, { Component } from 'react';
import './Step.css';

class Step extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qStr: 'Kysymys',
      step: 0,
      answer: null,
      correct: false,
      score: 0,
      questions: [
        { /* placeholder */},
        {
          q: "Minä vuonna Yliskulman puukoulu on valmistunut ja opiskelu siellä aloitettu?",
          a: ['1825', '1898', '1923', '1959'],
          c: 1,
          e: "Vanha puukoulu Vartinmäellä perustettiin 1898 ja on edelleen koulukäytössä. Lisäksi pihapiirissä on 1950-luvulla rakennettu kivikoulu sekä 2000-luvulla rakennettu käsityötalo.",
          i: "koulu200.jpg"
        },
        {
          q: "Mikä on nimeltään Pyhällöntien alussa oleva kivisilta joka vie yli Savijoen?",
          a: ['Suomensilta', 'Hämeensilta', 'Huilunsilta', 'Alhosilta'],
          c: 0,
          e: "Suomensilta vei Savijoen yli jo Härkätien muinaiset kulkijat 1600-luvulla. Siltaa pidettiin aikoinaan varsinaisen Suomen eli Varsinais-Suomen ja Hämeen rajana. Puisen sillan paikalle rakennettiin kivisilta vuonna 1916.",
          i: "silta.jpg"
        },
        {
          q: "Yliskulman Parmaharjulla on vuonna 1969 käyttöönotettu K82-hyppyrimäki. Kuka voitti suomenmestaruuden mäessä vuonna 1983?",
          a: ['Frans Tähkävuori', 'Anton Innauer', 'Jari Puikkonen', 'Matti Nykänen'],
          c: 3,
          e: "Matti Nykänen hyppäsi mestariksi vuoden 1983 SM-kilpailuissa uudella mäkiennätyksellä 80 metriä. Viimeksi mäestä on hypätty 2013, jolloin Veli-Matti Lindström ja Frans Tähkävuori hyppäsivät uudeksi ennätykseksi 85 m. Mäki on edelleen hyppykunnossa, ja alastulorinteen portaiden 300 askelmaa ovat kuntoilijoiden suosiossa.",
          i: "parma.jpg"
        },
        {
          q: "Mikä ei ole Yliskulman alueen vanha kylä?",
          a: ['Hyssälä', 'Huilu', 'Hyvättylä', 'Alhojoki'],
          c: 2,
          e: "Hyvättylä ei ole Yliskulmalla, vaan se on nykyistä Liedon keskustaa. Huilun kylässä oli 1500-luvulla Hämeen Härkätien kestikievari. Hyssälän ja Alhojoen kylät ovat syntyneet Savijoen sivujoen Alhojoen varrelle, jossa asutusta on ollut jo kivikaudella. ",
          i: "huilu.jpg"
        },
        {
          q: "Mitä seuraavista tuotteista ei valmisteta Yliskulmalla?",
          a: ['Puusepäntuotteet', 'Ohutlevykoneet', 'Pizzat', 'Jäätelöpuikot'],
          c: 3,
          e: "Yliskulmalaista jäätelöä ei valitettavasti saa. Sekin oli mahdollista vuoteen 1986 saakka, kun Patas-jäätelötehdas valmisti Huiluntien varressa Urheilutikkuja ja muuta hyvää. Nykyään rakennuksessa toimii mm. puusepänverstas. Pizzaa paistetaan Liedonperäntien alussa olevassa baarissa. Yliskulman vanhan osuusmeijerin tontilla taas sitten sijaitsee ohutlevykoneita valmistavan yrityksen toimitilat.",
          i: "patas.jpg"
        },
        {
          q: "Minkä yhdistyksen/seuran toimintaan et voi osallistua Yliskulmalla?",
          a: ['Partio', 'Liedon Pallo', '4H', 'Lieto-Opisto'],
          c: 0,
          e: "Partiotoimintaa ei Yliskulmalla tällä hetkellä ole, mutta tulevaisuudessa sekin on hyvin mahdollista! Liedon Pallolla on Yliskulmalla jalkapallojoukkue, joka harjoittelee kesäisin hienolla Hyssälän nurmikentällä. 4H:n kerhoon ja Lieto-opiston erinäisille kursseille voi osallistua Yliskulman koululla.",
          i: "http://yliskulma.fi/images/yliskulma-fudis-500.jpg"
        },
        {
          q: "Mitä tapahtumaa ei ole koskan järjestetty Yliskulmalla?",
          a: ['Tanssikurssi Nuorisoseurantalolla', 'Onkikilpailut Paimionjoessa', 'Yleisurheilukilpailut Yliskulman kentällä', 'Basehyppykurssi Parmaharjulla'],
          c: 3,
          e: "Kylällä toimii useita eri yhdistyksiä, jotka järjestävät kyläläisille ja muillekin kaikenlaista toimintaa ja tapahtumia. Toistaiseksi kuitenkin Parmaharjulla on hypätty lähinnä sukset jalassa, ei varjon kanssa.",
          i: "http://yliskulma.fi/images/lt.jpg"
        },
        {
          q: "Jos rakennat talon Yliskulmalle, mitä seuraavista ei ole mahdollista uuteen kotiisi saada?",
          a: ['Valokuitu', '5G', 'Kunnan vesijohto ja viemäri', 'Suuri tontti'],
          c: 1,
          e: "Yliskulmalla on alueesta riippuen saatavilla kunnallistekniikka, valokuituyhteydet ja omaa rauhaa ympärille. 5G-yhteydet ovat vasta tulossa, mutta valokuitu tai 4G hoitaa homman.",
          i: "http://yliskulma.fi/images/katava2.jpg"
        },
        {
          q: "Mistä materiaalista on valmistettu Parmaharjulle vuonna 2018 rakennettu grillikota?",
          a: ['Lannasta', 'Tiilestä', 'Oljesta', 'Hampusta'],
          c: 3,
          e: "Turun AMK rakensi yhteistyössä Liedon kunnan ja Liedon Huru-ukkojen kanssa Parmaharjun luontopolkujen yhteyteen hampusta grillikodan. Hamppukodalle löytyy opasteet reitin varrelta ja se on merkitty Parmaharjun opaskarttaan.",
          i: "hamppukota.jpg"
        },
        {
          q: "Mikä on Mahlion tornivuoren korkeus merenpinnasta?",
          a: ['55 m', '88 m', ' 101 m', ' 120 m'],
          c: 1,
          e: "Tornivuoren korkeus on 88 metriä. Tähän ei ole vielä laskettu mukaan tornin laella olevaa näkötornia, josta voi nähdä jopa kolmenkymmenen kilometrin päähän.",
          i: "torni.jpg"
        },
      ],
      evaluation: [
        'Huh, eikö muka yhtään oikein!? Kokeilehan uudelleen, josko muistaisit jo oikeat vastaukset!',
        'Huh, vain yksi oikein!? Kokeilehan uudelleen, josko muistaisit jo oikeat vastaukset!',
        'Nojoo, kaksi on parempi kuin ei yhtään! Testaahan uudelleen josko menisi jo kaikki oikein!',
        'Nojoo, hyvä yritys! Parempaankin varmasti kyllä pystyt jos vastaat uudelleen!',
        'Hmm, ei toivotonta! Selkeästi olet vähintäänkin kuullut tai lukenut Yliskulmasta ennenkin!',
        'Hmm, ihan hyvä tulos! Selkeästi olet vähintäänkin kuullut tai lukenut Yliskulmasta ennenkin, ellet peräti käväissytkin joskus!',
        'Jees, selvästikin tiedät jotain Yliskulmasta! Olet tainnut vähintäänkin käydä joskus Yliskulmalla tai peräti muuttanut jo Yliskulmalle.',
        'Ei lainkaan huono tulos! Arvatenkin Sinulla on jotain yhteyksiä Yliskulmaan tai peräti asut jo Yliskulmalla.',
        'Mahtavaa, hyvä tulos! Arvatenkin Sinulla on jotain yhteyksiä Yliskulmaan tai peräti asut jo Yliskulmalla.',
        'Jee, melkein täydet pojot! Taidat olla Yliskulmalaisia tai muuten vain fiksu tyyppi!',
        'Onnittelut, sait täydet pisteet! Olet taatusti elänyt vähintään koko ikäsi Yliskulmalla!'
      ],
      endwords: {
        desc: 'Tietovisan toteutti Yliskulman Kyläyhdistys ry. - yliskulma.fi',
        link: 'http://yliskulma.fi'
      }
    };
  
    // This binding is necessary to make `this` work in the callback
    this.startQuiz = this.startQuiz.bind(this);
    this.lockAnswer = this.lockAnswer.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.showCorrect = this.showCorrect.bind(this);
  }

  startQuiz() {
    this.setState({ step: 1, score: 0 });
  }

  nextQuestion() {
    this.setState(state => ({ step: state.step+1, answer: null, correct: false }));
  }

  showCorrect() {
    this.setState(state => ({ correct: true }));
    //this.setState(state => ({ step: state.step+1, answer: null }));
  }

  lockAnswer(a) {
    var score = this.state.score;

    if (this.state.answer) {
      return;
    }

    if (a===this.state.questions[this.state.step]["c"]) {
      score = this.state.score + 1;
      console.log("CORRECT")
    } else {
      console.log("WRONG")
    }
    this.setState(state => ({ answer: a, score: score }));
    setTimeout(this.showCorrect, 2000);
    //this.setState(state => ({ step: state.step+1 }));
  }

  render() {
    if (this.state.step==0) {
      return (
        <div className="Step">
          <span className="question">
            <h2>Yliskulma-tietovisa</h2>
            Testaa mitä tiedät Yliskulman kylästä!
            <br/> <br/>
          </span>
          <button onClick={this.startQuiz}>Aloita</button>
        </div>
      );
    } else if (this.state.correct == true) {
      return (
        <div className="Step">
          <span className="question">
            {this.state.questions[this.state.step]["c"]==this.state.answer?
              <span>Hienoa, vastasit aivan oikein!</span>:
              <span>Hups, väärä vastaus!</span>}
            {/*this.state.questions[this.state.step]["a"][this.state.questions[this.state.step]["c"]]*/}
            </span>
            <p/>
            <div className="row">
              <div className="column"><img src={this.state.questions[this.state.step]["i"]}/></div>
              <div className="column">{this.state.questions[this.state.step]["e"]}</div>
            </div>
          <p/>
          <button onClick={this.nextQuestion}>Jatka</button>
        </div>
      )
    } else if (this.state.step==11) {
      return (
        <div className="Step">
          <span className="question">
            Sait yhteensä {this.state.score}/10 pistettä!
          </span>
          <p/>
          <span>
            {this.state.evaluation[this.state.score]}
          </span>
          <p/>
          <button onClick={this.startQuiz}>Uudestaan</button>
          <p/>
          <span className="endwords">
            <i><a target='_blank' href={this.state.endwords['link']}>{this.state.endwords['desc']}</a></i>
          </span>
        </div>
      );
    }
    return (
      <div className="Step">
        <span className="question">
          {this.state.step}: {this.state.questions[this.state.step]["q"]}
        </span>
        <p/>
        { this.state.questions[this.state.step]["a"].map((item, index) => (
          <button className=
            {index===this.state.answer ?
              (index===this.state.questions[this.state.step]["c"]?"green flash":"red flash") :
              (this.state.answer != null && index===this.state.questions[this.state.step]["c"]?"green":"")
            } onClick={() => this.lockAnswer(index)}>{item}</button>   
        ))}
      </div>
    );
  }
}

export default Step;

